// Dummy data for Koperasi Andalan Dapur Nusantara — Indonesian context, Rupiah currency
// All data here is mock; no backend wiring.

export const formatRupiah = (value) =>
  new Intl.NumberFormat("id-ID", { style: "currency", currency: "IDR", maximumFractionDigits: 0 }).format(value || 0);

export const formatNumber = (value) =>
  new Intl.NumberFormat("id-ID").format(value || 0);

export const formatDate = (iso) =>
  new Date(iso).toLocaleDateString("id-ID", { day: "numeric", month: "long", year: "numeric" });

export const koperasiInfo = {
  name: "Koperasi Andalan Dapur Nusantara",
  tagline: "Tumbuh Bersama, Sejahtera Bersama",
  founded: 2008,
  members: 4827,
  branches: 6,
  villages: 42,
  shu2024: 1240000000,
  // Data kontak & legal RESMI diisi lewat frontend/.env (REACT_APP_COMPANY_*) saat build.
  // Footer, halaman Kontak, dan Syarat & Ketentuan memakai nilai ini — reviewer payment
  // gateway (Midtrans) memeriksa bahwa data ini asli.
  address: process.env.REACT_APP_COMPANY_ADDRESS || "Jl. Gotong Royong No. 27, Yogyakarta 55281",
  email: process.env.REACT_APP_COMPANY_EMAIL || "halo@dapurnusantara.id",
  phone: process.env.REACT_APP_COMPANY_PHONE || "+62 274 555 0127",
  wa: process.env.REACT_APP_COMPANY_WA || "+62 812 9001 4827",
  legalNumber: process.env.REACT_APP_COMPANY_LEGAL_NUMBER || "271/BH/KDK.12/IV/2008",
  hours: process.env.REACT_APP_COMPANY_HOURS || "Senin–Jumat 08.00–17.00 WIB",
  website: process.env.REACT_APP_COMPANY_WEBSITE || "https://andalandapurnusantara.com",
  // Rekening tujuan Transfer Manual. Bila kosong, opsi Transfer Manual disembunyikan.
  bankName: process.env.REACT_APP_BANK_NAME || "",
  bankAccount: process.env.REACT_APP_BANK_ACCOUNT || "",
  bankHolder: process.env.REACT_APP_BANK_HOLDER || "",
};

export const heroImages = {
  primary: "https://images.unsplash.com/photo-1517456793572-1d8efd6dc135?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwyfHxjb21tdW5pdHklMjBnYXRoZXJpbmclMjB3YXJtfGVufDB8fHx8MTc4MTE2NTA5OXww&ixlib=rb-4.1.0&q=85",
  secondary: "https://images.unsplash.com/photo-1517457373958-b7bdd4587205?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHw0fHxjb21tdW5pdHklMjBnYXRoZXJpbmclMjB3YXJtfGVufDB8fHx8MTc4MTE2NTA5OXww&ixlib=rb-4.1.0&q=85",
  team: "https://images.unsplash.com/photo-1576267423445-b2e0074d68a4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzR8MHwxfHNlYXJjaHwxfHxvZmZpY2UlMjB3b3JrZXJzJTIwc21pbGluZ3xlbnwwfHx8fDE3ODExNjUxMDB8MA&ixlib=rb-4.1.0&q=85",
};

export const pengurus = [
  { name: "Dr. M. Fajar Sidik", role: "Ketua Pengurus", since: 2018, avatar: "https://i.pravatar.cc/200?img=12" },
  { name: "Ibu Lestari Nugraha", role: "Sekretaris", since: 2020, avatar: "https://i.pravatar.cc/200?img=49" },
  { name: "Bpk. Rahmat Hidayat", role: "Bendahara", since: 2019, avatar: "https://i.pravatar.cc/200?img=33" },
  { name: "Ibu Sari Wulandari", role: "Pengawas Utama", since: 2021, avatar: "https://i.pravatar.cc/200?img=23" },
  { name: "Bpk. Andi Pratama", role: "Manajer Operasional", since: 2022, avatar: "https://i.pravatar.cc/200?img=15" },
  { name: "Ibu Dewi Anjani", role: "Manajer Keuangan", since: 2023, avatar: "https://i.pravatar.cc/200?img=44" },
];

export const testimonials = [
  { name: "Marwan, Petani Kopi", quote: "Sejak gabung 4 tahun lalu, SHU saya bisa untuk modal panen tiap tahun. Transparan dan adil.", rating: 5 },
  { name: "Nining, UMKM Catering", quote: "Pinjaman modalnya cair cepat, bunganya manusiawi. Saya bisa fokus berkembang.", rating: 5 },
  { name: "Pak Edi, Pensiunan Guru", quote: "Simpanan sukarela saya tumbuh konsisten. Lebih tenang dibanding deposito bank.", rating: 5 },
  { name: "Ibu Siti, Ibu Rumah Tangga", quote: "Harga belanja sembako di toko koperasi lebih murah, dan dapat poin SHU akhir tahun.", rating: 5 },
];

export const news = [
  { id: 1, title: "RAT 2025 Diselenggarakan 15 Maret — Anggota Wajib Hadir", category: "Pengumuman", date: "2026-02-08", excerpt: "Rapat Anggota Tahunan tahun ini akan membahas pembagian SHU, evaluasi kinerja, dan rencana ekspansi cabang.", image: "https://images.unsplash.com/photo-1543269865-cbf427effbad?w=800&q=80" },
  { id: 2, title: "Koperasi Andalan Dapur Nusantara Buka Cabang Ke-7 di Magelang", category: "Berita", date: "2026-01-22", excerpt: "Sebagai upaya melayani lebih dekat, cabang baru hadir dengan layanan simpan-pinjam dan toko modern.", image: "https://images.unsplash.com/photo-1556761175-5973dc0f32e7?w=800&q=80" },
  { id: 3, title: "Program Kredit UMKM Bunga 0,8% per Bulan", category: "Program", date: "2026-01-10", excerpt: "Anggota aktif min. 2 tahun dapat mengakses pinjaman modal usaha dengan plafon hingga Rp 50 juta.", image: "https://images.unsplash.com/photo-1607082348824-0a96f2a4b9da?w=800&q=80" },
  { id: 4, title: "Workshop Literasi Keuangan Digital — Gratis untuk Anggota", category: "Edukasi", date: "2025-12-18", excerpt: "Belajar mengelola tabungan, investasi, dan dana darurat bersama mentor bersertifikasi OJK.", image: "https://images.unsplash.com/photo-1552664730-d307ca884978?w=800&q=80" },
];

export const galeri = [
  "https://images.unsplash.com/photo-1556761175-b413da4baf72?w=600&q=80",
  "https://images.unsplash.com/photo-1542838132-92c53300491e?w=600&q=80",
  "https://images.unsplash.com/photo-1488521787991-ed7bbaae773c?w=600&q=80",
  "https://images.unsplash.com/photo-1606237906294-ae86d103d715?w=600&q=80",
  "https://images.unsplash.com/photo-1542838132-92c53300491e?w=600&q=80",
  "https://images.unsplash.com/photo-1543269865-cbf427effbad?w=600&q=80",
];

export const products = [
  { id: "p1", name: "Beras Premium Pandan Wangi 5kg", category: "Sembako", price: 78000, memberPrice: 69000, stock: 124, image: "https://images.unsplash.com/photo-1586201375761-83865001e31c?w=600&q=80", featured: true, rating: 4.9, sold: 312, tags: ["Best Seller"] },
  { id: "p2", name: "Kopi Robusta Lokal 250g", category: "Minuman", price: 45000, memberPrice: 38500, stock: 86, image: "https://images.unsplash.com/photo-1559056199-641a0ac8b55e?w=600&q=80", featured: true, rating: 4.8, sold: 198, tags: ["Produk Anggota"] },
  { id: "p3", name: "Minyak Goreng Curah 2L", category: "Sembako", price: 36000, memberPrice: 32000, stock: 210, image: "https://images.unsplash.com/photo-1474979266404-7eaacbcd87c5?w=600&q=80", rating: 4.7, sold: 480 },
  { id: "p4", name: "Madu Hutan Murni 500ml", category: "Kesehatan", price: 120000, memberPrice: 99000, stock: 32, image: "https://images.unsplash.com/photo-1587049352846-4a222e784d38?w=600&q=80", featured: true, rating: 5.0, sold: 87, tags: ["Premium"] },
  { id: "p5", name: "Sayur Organik Mix 1kg", category: "Sayur & Buah", price: 28000, memberPrice: 24000, stock: 58, image: "https://images.unsplash.com/photo-1606237906294-ae86d103d715?w=600&q=80", rating: 4.6, sold: 156 },
  { id: "p6", name: "Telur Ayam Kampung 10 butir", category: "Sembako", price: 32000, memberPrice: 28000, stock: 98, image: "https://images.unsplash.com/photo-1587486913049-53fc88980cfc?w=600&q=80", rating: 4.8, sold: 224 },
  { id: "p7", name: "Gula Aren Organik 500g", category: "Sembako", price: 22000, memberPrice: 18500, stock: 142, image: "https://images.unsplash.com/photo-1610725664285-7c57e6eeac3f?w=600&q=80", rating: 4.7, sold: 178 },
  { id: "p8", name: "Teh Hijau Daun Kering 100g", category: "Minuman", price: 18000, memberPrice: 15000, stock: 75, image: "https://images.unsplash.com/photo-1597318181409-cf64d0b5d8a2?w=600&q=80", rating: 4.5, sold: 92 },
];

export const productCategories = ["Semua", "Sembako", "Sayur & Buah", "Minuman", "Kesehatan", "Rumah Tangga"];

export const memberProfile = {
  id: "KD-2021-00427",
  name: "Annisa Rahmawati",
  email: "annisa.rahma@example.id",
  phone: "+62 812 3344 5566",
  joinedAt: "2021-08-14",
  avatar: "https://i.pravatar.cc/200?img=45",
  status: "Anggota Aktif",
  level: "Anggota Emas",
  activityScore: 92,
  branch: "Cabang Yogyakarta Pusat",
  occupation: "Wiraswasta — Catering Rumahan",
  address: "Jl. Mawar No. 14, Gondokusuman, Yogyakarta",
};

export const memberSavings = {
  pokok: 500000,
  wajib: 3600000,
  sukarela: 12450000,
  total: 16550000,
  growth: 14.2,
};

export const savingsHistory = [
  { date: "2026-02-01", type: "Simpanan Wajib", amount: 150000, balance: 3600000 },
  { date: "2026-01-28", type: "Simpanan Sukarela", amount: 500000, balance: 12450000 },
  { date: "2026-01-15", type: "SHU Diterima", amount: 845000, balance: 11950000 },
  { date: "2026-01-01", type: "Simpanan Wajib", amount: 150000, balance: 3450000 },
  { date: "2025-12-20", type: "Simpanan Sukarela", amount: 1000000, balance: 11105000 },
  { date: "2025-12-01", type: "Simpanan Wajib", amount: 150000, balance: 3300000 },
];

export const shuTracker = {
  estimasi2025: 1240000,
  diterima2024: 845000,
  jasaModal: 520000,
  jasaUsaha: 720000,
  progress: 78,
  history: [
    { year: 2021, amount: 320000 },
    { year: 2022, amount: 480000 },
    { year: 2023, amount: 612000 },
    { year: 2024, amount: 845000 },
    { year: 2025, amount: 1240000 },
  ],
};

export const memberOrders = [
  { id: "ORD-202602-0142", date: "2026-02-05", items: 4, total: 287000, status: "Dikirim", payment: "Transfer BCA", tracking: "JNE 9281731", eta: "2026-02-09" },
  { id: "ORD-202601-1029", date: "2026-01-22", items: 2, total: 113500, status: "Selesai", payment: "Dompet Anggota", tracking: "SiCepat 7281", eta: "2026-01-25" },
  { id: "ORD-202601-0871", date: "2026-01-10", items: 7, total: 412800, status: "Selesai", payment: "QRIS", tracking: "JNT 1822", eta: "2026-01-13" },
  { id: "ORD-202512-0653", date: "2025-12-28", items: 3, total: 159000, status: "Selesai", payment: "Transfer Mandiri", tracking: "Pos 6612", eta: "2025-12-31" },
  { id: "ORD-202512-0421", date: "2025-12-15", items: 5, total: 298000, status: "Dikomplain", payment: "QRIS", tracking: "JNE 1102", eta: "2025-12-18" },
];

export const orderStatuses = ["Menunggu Bayar", "Dibayar", "Dikemas", "Dikirim", "Diterima", "Selesai"];

// ----- Admin / Management dummy -----

export const adminKPI = {
  totalMembers: 4827,
  newMembers30d: 84,
  activeOrders: 142,
  pendingApproval: 17,
  cashOnHand: 2480000000,
  monthRevenue: 384000000,
  monthGrowth: 12.4,
  stockAlerts: 6,
};

export const revenueSeries = [
  { month: "Sep", penjualan: 248, simpanan: 312 },
  { month: "Okt", penjualan: 286, simpanan: 298 },
  { month: "Nov", penjualan: 302, simpanan: 340 },
  { month: "Des", penjualan: 348, simpanan: 365 },
  { month: "Jan", penjualan: 372, simpanan: 388 },
  { month: "Feb", penjualan: 384, simpanan: 402 },
];

export const memberGrowth = [
  { month: "Sep", anggota: 4490 },
  { month: "Okt", anggota: 4582 },
  { month: "Nov", anggota: 4651 },
  { month: "Des", anggota: 4712 },
  { month: "Jan", anggota: 4768 },
  { month: "Feb", anggota: 4827 },
];

export const categoryShare = [
  { name: "Sembako", value: 42 },
  { name: "Minuman", value: 18 },
  { name: "Sayur & Buah", value: 16 },
  { name: "Kesehatan", value: 14 },
  { name: "Lainnya", value: 10 },
];

export const adminMembers = [
  { id: "KD-2021-00427", name: "Annisa Rahmawati", email: "annisa@example.id", phone: "+62 812 3344 5566", joined: "2021-08-14", status: "Aktif", level: "Emas", saving: 16550000, branch: "Yogyakarta Pusat" },
  { id: "KD-2019-00128", name: "Bima Setiawan", email: "bima@example.id", phone: "+62 813 5512 1922", joined: "2019-03-21", status: "Aktif", level: "Platinum", saving: 42870000, branch: "Sleman" },
  { id: "KD-2023-00721", name: "Citra Maharani", email: "citra@example.id", phone: "+62 815 9921 3010", joined: "2023-11-02", status: "Pending", level: "Reguler", saving: 1200000, branch: "Yogyakarta Pusat" },
  { id: "KD-2020-00342", name: "Doni Pratama", email: "doni@example.id", phone: "+62 812 8821 4451", joined: "2020-06-08", status: "Aktif", level: "Emas", saving: 23410000, branch: "Bantul" },
  { id: "KD-2022-00598", name: "Erna Susanti", email: "erna@example.id", phone: "+62 819 7765 0921", joined: "2022-02-19", status: "Nonaktif", level: "Perak", saving: 8230000, branch: "Magelang" },
  { id: "KD-2024-00882", name: "Fajar Nugroho", email: "fajar@example.id", phone: "+62 821 4490 7714", joined: "2024-09-04", status: "Pending", level: "Reguler", saving: 500000, branch: "Sleman" },
  { id: "KD-2018-00071", name: "Gita Larasati", email: "gita@example.id", phone: "+62 818 2231 5512", joined: "2018-04-30", status: "Aktif", level: "Platinum", saving: 58210000, branch: "Yogyakarta Pusat" },
  { id: "KD-2022-00514", name: "Hendra Wijaya", email: "hendra@example.id", phone: "+62 816 7791 0042", joined: "2022-07-12", status: "Aktif", level: "Emas", saving: 19850000, branch: "Bantul" },
];

export const adminOrders = [
  { id: "ORD-202602-0142", member: "Annisa Rahmawati", items: 4, total: 287000, status: "Dikirim", payment: "Transfer BCA", date: "2026-02-05" },
  { id: "ORD-202602-0141", member: "Bima Setiawan", items: 2, total: 156000, status: "Dikemas", payment: "QRIS", date: "2026-02-05" },
  { id: "ORD-202602-0140", member: "Doni Pratama", items: 6, total: 412000, status: "Dibayar", payment: "Dompet Anggota", date: "2026-02-04" },
  { id: "ORD-202602-0139", member: "Gita Larasati", items: 1, total: 99000, status: "Menunggu Bayar", payment: "QRIS", date: "2026-02-04" },
  { id: "ORD-202602-0138", member: "Hendra Wijaya", items: 3, total: 168000, status: "Diterima", payment: "Transfer BNI", date: "2026-02-03" },
  { id: "ORD-202602-0137", member: "Erna Susanti", items: 5, total: 320000, status: "Selesai", payment: "QRIS", date: "2026-02-02" },
  { id: "ORD-202602-0136", member: "Citra Maharani", items: 2, total: 88500, status: "Selesai", payment: "Transfer BCA", date: "2026-02-02" },
];

export const adminFinance = [
  { id: "TRX-001", date: "2026-02-08", desc: "Simpanan Wajib — Batch Februari", category: "Penerimaan", amount: 184500000, balance: 2480000000 },
  { id: "TRX-002", date: "2026-02-07", desc: "Pembayaran Supplier — Kopi Robusta", category: "Pengeluaran", amount: -28400000, balance: 2295500000 },
  { id: "TRX-003", date: "2026-02-06", desc: "Penjualan Toko Online — Harian", category: "Penerimaan", amount: 12480000, balance: 2323900000 },
  { id: "TRX-004", date: "2026-02-05", desc: "Pencairan SHU — Anggota Premium", category: "Pengeluaran", amount: -48200000, balance: 2311420000 },
  { id: "TRX-005", date: "2026-02-04", desc: "Setoran Tunai Cabang Magelang", category: "Penerimaan", amount: 67800000, balance: 2359620000 },
  { id: "TRX-006", date: "2026-02-03", desc: "Operasional Cabang & Listrik", category: "Pengeluaran", amount: -14200000, balance: 2291820000 },
];

export const adminProducts = products.map((p) => ({
  ...p,
  supplier: ["UMKM Sinar Tani", "Kelompok Tani Merapi", "CV Berkah Alam", "UD Mekar Sari"][p.id.charCodeAt(1) % 4],
  costPrice: Math.round(p.price * 0.72),
  status: p.stock > 50 ? "Aktif" : p.stock > 20 ? "Stok Rendah" : "Kritis",
}));

export const roles = [
  { name: "Super Admin", count: 2, permissions: 24, color: "forest" },
  { name: "Admin Keuangan", count: 3, permissions: 12, color: "amber" },
  { name: "Admin Toko", count: 5, permissions: 14, color: "sage" },
  { name: "Admin Keanggotaan", count: 4, permissions: 10, color: "terracotta" },
  { name: "Operator", count: 8, permissions: 6, color: "stone" },
];

export const auditTrail = [
  { actor: "M. Fajar Sidik", role: "Super Admin", action: "Menyetujui anggota baru #KD-2024-00882", time: "10 menit lalu" },
  { actor: "Dewi Anjani", role: "Admin Keuangan", action: "Mencatat pembayaran supplier Rp 28.400.000", time: "1 jam lalu" },
  { actor: "Andi Pratama", role: "Admin Toko", action: "Update stok 'Beras Premium' +50 kg", time: "3 jam lalu" },
  { actor: "Lestari Nugraha", role: "Admin Keanggotaan", action: "Memperbarui data anggota #KD-2019-00128", time: "Kemarin" },
  { actor: "Rahmat Hidayat", role: "Super Admin", action: "Menjalankan kalkulasi SHU Q4 2025", time: "2 hari lalu" },
];
